module.exports = "/packs/images/svg/weekly-prog/print~c409c429c1b441e1af23498dc5a3d6bc.svg";